import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { TokenService } from '../services/token.service';
import { PermissionsService } from '../services/permissions.service';

/**
 * Ante cualquier 401 del backend (sesion.i: 1 hora sin actividad o sesion
 * iniciada en otro dispositivo) cierra la sesion con el aviso de expiracion.
 * Antes el 401 solo se detectaba en PermissionsGuard; en rutas sin guard
 * (pagos, notificaciones, configuracion) o al quedarse quieto en una pantalla,
 * el error se perdia y la UI quedaba vacia sin avisar.
 */
@Injectable()
export class SesionVencidaInterceptor implements HttpInterceptor {
  // Injector en lugar de inyeccion directa: TokenService depende de HttpClient,
  // y HttpClient depende de los interceptores (dependencia circular).
  constructor(private injector: Injector) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Many services cache getHttpHeaders() in their constructor, so after a
    // re-login without reload they keep sending the previous session token.
    // Always send the current one.
    if (req.headers.has('token')) {
      const token = this.injector.get(TokenService).getToken() || '';
      req = req.clone({ setHeaders: { token } });
    }
    return next.handle(req).pipe(
      catchError((err) => {
        const tokenService = this.injector.get(TokenService);
        // Solo WebSpeed valida la sesion (sesion.i); sin token no hay sesion
        // que vencer (login, registro-productor, reset-password).
        if (
          err instanceof HttpErrorResponse &&
          err.status === 401 &&
          req.url.includes('/cgi-bin/') &&
          !req.url.includes('login.r') &&
          tokenService.getToken()
        ) {
          this.injector.get(PermissionsService).limpioPermisos();
          tokenService.logOut();
        }
        return throwError(() => err);
      })
    );
  }
}
